import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/watchlist/Button';
import CollectionItem from './CollectionItem';
import NewWatchlistForm from './NewWatchlistForm';
import { Menu, MenuHeader } from './styled';
import slice, { selectors } from './slice';

const { actions } = slice;

function MenuOverlay() {
  const dispatch = useDispatch();
  const {
    available,
    isCollectionLoading,
    isFormOpen,
    activeWatchlistId: activeId,
  } = useSelector(selectors);

  const handleCreateClick = () => {
    dispatch(actions.handleSetFormOpen({ isOpen: true }));
  };

  return (
    <>
      <MenuHeader>MY WATCHLIST COLLECTION</MenuHeader>
      <Menu>
        {available.map(
          ({ name, watchlist_id: id, is_default: isDefault }, index) => (
            <Menu.Item
              className={activeId === id && 'active'}
              key={`menu-item-${id}`}
              disabled={isCollectionLoading}
            >
              <CollectionItem
                index={index}
                name={isDefault ? 'All Watchlist' : name}
                watchlistid={id}
              />
            </Menu.Item>
          ),
        )}
      </Menu>
      <Flex
        width="100%"
        padding="8px 8px"
        style={{
          background: 'white',
          border: '1px solid rgb(218, 218, 218)',
          borderTop: 'none',
          borderRadius: '0 0 3px 3px',
        }}
      >
        {isFormOpen ? (
          <NewWatchlistForm />
        ) : (
          <Button
            onClick={handleCreateClick}
            loading={isCollectionLoading}
            type="primary"
            block
          >
            Create New Watchlist
          </Button>
        )}
      </Flex>
    </>
  );
}

export default MenuOverlay;
